import { FieldBase } from '@/components/form/fieldBase';
import { useFieldContext } from '@/components/form/formHooks';
import { FieldProps } from '@/components/form/types';
import { TimeInput } from '@/components/Input/TimeInput';

export function FieldTimeInput({
  label,
  description,
  placeholder,
  isRequired,
  className,
  ...inputProps
}: FieldProps & React.ComponentProps<typeof TimeInput>) {
  const field = useFieldContext<string>();
  return (
    <FieldBase
      label={label}
      description={description}
      isRequired={isRequired}
      className={className}>
      <TimeInput
        id={field.name}
        placeholder={placeholder}
        value={field.state.value}
        onChange={(e) => field.handleChange(e.target.value)}
        onBlur={field.handleBlur}
        {...inputProps}
      />
    </FieldBase>
  );
}
